import { render } from "./RAWSDetailsView.vue?vue&type=template&id=7d460139&scoped=true"
import script from "./RAWSDetailsView.vue?vue&type=script&lang=js"
export * from "./RAWSDetailsView.vue?vue&type=script&lang=js"

import "./RAWSDetailsView.vue?vue&type=style&index=0&id=7d460139&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7d460139"]])

export default __exports__